type StatisticRow = Record<string, any>;

export const mergeSumObjShallow = (data: StatisticRow[] = []) => {
  const result: StatisticRow = {};

  data.filter(Boolean).forEach((basket) => {
    Object.entries(basket).forEach(([key, value]) => {
      if (value && typeof value === "object" && value.constructor === Object) {
        return;
      }

      if (result[key] && !Number.isNaN(Number(value)) && !Number.isNaN(Number(result[key]))) {
        result[key] += value;
        return;
      }

      result[key] = value || 0;
    });
  });

  return result;
};

const mergeProductStatistics = (rows: StatisticRow[], key: string) => {
  const firstList = rows[0]?.[key] || [];

  return firstList.map((_, index) => mergeSumObjShallow(rows.map((row) => row?.[key]?.[index]).filter(Boolean)));
};

export const mergeSiteStatistics = (rows: StatisticRow[] = []) => {
  const validRows = rows.filter(Boolean);
  if (validRows.length === 0) return null;
  if (validRows.length === 1) return validRows[0];

  return {
    date: validRows[0].date,
    site: validRows[0].site,
    total_amount: validRows.reduce((sum, item) => sum + (item.total_amount || 0), 0),
    total_amount_info: mergeSumObjShallow(validRows.map((item) => item.total_amount_info)),
    statestics_pacakge_products: mergeProductStatistics(validRows, "statestics_pacakge_products"),
    statestics_ticket_products: mergeProductStatistics(validRows, "statestics_ticket_products"),
    statestics_option_products: mergeProductStatistics(validRows, "statestics_option_products"),
  };
};

const getStatisticDateKey = (row: StatisticRow) => String(row?.date || "").slice(0, 10);

export const upsertStatisticByDate = (rows: StatisticRow[] = [], nextRow: StatisticRow | null | undefined) => {
  if (!nextRow?.date) return rows;

  const nextDate = getStatisticDateKey(nextRow);
  const nextRows = rows.filter((row) => getStatisticDateKey(row) !== nextDate);

  return [...nextRows, nextRow].sort((a, b) => getStatisticDateKey(a).localeCompare(getStatisticDateKey(b)));
};
